import * as React from "react";
import axios from 'axios';
import { useSelector } from "react-redux";

import plusBlueIcon from '../assets/images/plus_blue.svg';
import closeIcon from '../assets/images/cross-close.svg';
import calendarIcon from '../assets/images/calendar.svg';
import propertyIcon from '../assets/images/buildings-alt.svg';
import userIcon from '../assets/images/user-alt.svg';
import clockIcon from '../assets/images/clock.svg';
import locationPinIcon from '../assets/images/location-pin.svg';
import warning from '../assets/images/warning.svg';
import { getEstateAndOfficeSetting } from "../services/commonService";
import { variables } from "../Variables";

const { useState, useEffect } = React;

export const ConfirmSlot = ({ handleClose, saveNewWhiseEvent, calendarActions, whiseAgents, officeSettings, setCurrentStep,
    automaticSlotAccept, setAutomaticSlotAccept }) => {
    const [availableSlots, setAvailableSlots] = useState([]);
    const [officeDefaultOptShow, setOfficeDefaultOptShow] = useState("");

    const reduxStatus = useSelector(state => state.statusFilter.statusFilter);
    const reduxAgent = useSelector(state => state.agentFilter.agentFilter);
    const reduxEventDetail = useSelector(state => state.eventDetail.eventDetail);
    const reduxProperty = useSelector(state => state.selectedProperty.selectedProperty);
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSetting = useSelector(state => state.setting.setting);
    const reduxBookAbleUntil = useSelector(state => state.bookAbleUntil.bookAbleUntil);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const getEstateAndOfficeSetting = async () => {
        try {
            let url = `${variables.API_URL}Preferences/GetEstateOrOfficeSetting?clientId=${reduxProperty.clientId}&estateId=${reduxProperty.id}&officeId=${reduxProperty.officeId}&actionType=ui&settingType=estate`;
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data) {
                console.log(response.data.automaticSlotAcceptation);
                setAutomaticSlotAccept(response.data.automaticSlotAcceptation);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getOfficeLevelSetting = async () => {
        try {
            let url = `${variables.API_URL}Preferences/GetEstateOrOfficeSetting?clientId=${reduxProperty.clientId}&estateId=${reduxProperty.id}&officeId=${reduxProperty.officeId}&actionType=ui&settingType=office`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data) {
                console.log(response.data);
                setOfficeDefaultOptShow(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getEstateAndOfficeSetting();
        getOfficeLevelSetting();
        setAutomaticSlotAccept("clientDefault");
    }, []);
    
    const moveToSetupInvitee = () => {
        /*setCurrentStep(3);*/
        setCurrentStep(4);
    }
    function toLocalISOString(date) {
        const offsetInMinutes = date.getTimezoneOffset();
        const adjustedDate = new Date(date.getTime() - offsetInMinutes * 60 * 1000);
        return adjustedDate.toISOString().slice(0, 19); // Remove milliseconds and 'Z'
    }

    useEffect(() => {
        if (reduxEventDetail && reduxEventDetail.availableHours.length > 0) {
            const datesArray = [...reduxEventDetail.availableHours];

            let sortedList = datesArray.sort(function (a, b) {
                return new Date(a.StartDateTime) - new Date(b.StartDateTime);
            });

            let bookAbleDateTime = new Date();
            if (reduxBookAbleUntil) {
                if (reduxBookAbleUntil.label == "days") {
                    bookAbleDateTime.setDate(bookAbleDateTime.getDate() + parseInt(reduxBookAbleUntil.value, 10));
                }
                else {
                    bookAbleDateTime.setHours(bookAbleDateTime.getHours() + parseInt(reduxBookAbleUntil.value, 10));
                }
            }

            let filterList = sortedList.filter(item => {
                let itemDateLocal = new Date(item.StartDateTime.replace("Z", ""));
                return itemDateLocal > bookAbleDateTime;
            });

            setAvailableSlots(filterList)
        }

    }, [reduxEventDetail, reduxBookAbleUntil])

    const onChangeAutomaticAcceptVal = (val) => {
        setAutomaticSlotAccept(val.target.value);
    }

    return (
        <>
            <div className="d-flex justify-content-between mb-3">
                <ul className="form-steps">
                    <li className="step-bar"></li>
                    <li className="step-bar"></li>
                    <li className="step-bar"></li>
                    <li className="step-bar active"></li>
                </ul>
                <img src={closeIcon} onClick={handleClose} className="cursor-pointer" />
            </div>
            <div>
                <p className="form-title mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalTitle"] : "New Event"}</p>
            </div>
            <div className="warning mb-2">
                <img src={warning} className="me-3" />
                <p className="mb-0">
                    {reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalFutureEventText"] : "Only future events will be catered."}
                </p>
            </div>
            <div>
                <p className="subtitle mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalSubTitleConfirmSlot"] : "Please confirm your new slot"}</p>
            </div>
            <div className="d-flex justify-content-between align-items-center border-bottom-end mb-4">
                <p className="subtitle mb-0"><img src={calendarIcon} className="me-2" />{reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalCalenderTypeLabel"] : "Calendar Type"}</p>
                <p className="subtitle mb-0">
                    {
                        calendarActions.length > 0 ?
                            calendarActions.map((item, index) => {
                                if (reduxEventDetail && reduxEventDetail.event && item.id == reduxEventDetail.event.EventType) {

                                    //let languageLabel = "";
                                    //if (item.name.toLowerCase() == "free slot") {
                                    //    languageLabel = reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalFreeSlotLabel"] : "free slot";
                                    //}

                                    return (
                                        <span className="visit-type-pill" key={index}>{item.name}</span>
                                        //<span className="visit-type-pill" key={index}>{languageLabel}</span>
                                    )
                                }
                            })
                            :
                            <></>
                    }
                </p>
            </div>
            <div className="d-flex justify-content-between align-items-center border-bottom-end mb-4">
                <p className="subtitle mb-0"><img src={propertyIcon} className="me-2" /> {reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalPropertyLabel"] : "Property"}</p>
                <div className="text-end">
                    <p className="subtitle mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["topHeaderIDLabel"] : "ID"} {reduxProperty.id}</p>
                    <p className="small-grey-text mb-0">
                        <img src={locationPinIcon} className="me-2" />
                        {
                            (reduxProperty.address == undefined ? "" : reduxProperty.address) + " " +
                            (reduxProperty.number == undefined ? "" : reduxProperty.number) + ", " +
                            (reduxProperty.zip == undefined ? "" : reduxProperty.zip) + " " +
                            (reduxProperty.city == undefined ? "" : reduxProperty.city)
                        }
                    </p>
                </div>
            </div>
            <div className="d-flex justify-content-between align-items-center border-bottom-end mb-4">
                <p className="subtitle mb-0"><img src={userIcon} className="me-2" /> {reduxLanguageTranslations ? reduxLanguageTranslations["newEventModalReviewAgentLbl"] : "Agent"}</p>
                <div className="text-end">
                    {
                        reduxAgent.length > 0 ?
                            reduxAgent.map(item => {
                                return (
                                    <div className="m-0 p-0">
                                        <p className="subtitle mb-0">{item.agentDetail.firstName + " " + item.agentDetail.name}</p>
                                        <p className="small-grey-text mb-0">
                                            {item.value}
                                        </p>
                                    </div>
                                )
                            })
                            :
                            <></>
                    }
                </div>
            </div>
            <div className="d-flex justify-content-between align-items-top border-bottom-end mb-4">
                <p className="subtitle mb-0"><img src={clockIcon} className="slots-img me-2" /> {reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalSlotLabel"] : "Slot"}</p>
                <div className="slots-container subtitle text-end">
                    {
                        availableSlots.length > 0 ?
                            availableSlots.map(item => {
                                let startDate = new Date(item.StartDateTime);
                                startDate.setMinutes(startDate.getMinutes() + startDate.getTimezoneOffset());
                                var eventdate = startDate.getDate();

                                let starthours = startDate.getHours() < 10 ? "0" + startDate.getHours() : startDate.getHours();
                                let startminutes = startDate.getMinutes() < 10 ? "0" + startDate.getMinutes() : startDate.getMinutes();
                                var start = starthours + ":" + startminutes;

                                let endDate = new Date(item.EndDateTime);
                                endDate.setMinutes(endDate.getMinutes() + endDate.getTimezoneOffset());
                                let endhours = endDate.getHours() < 10 ? "0" + endDate.getHours() : endDate.getHours();
                                let endminutes = endDate.getMinutes() < 10 ? "0" + endDate.getMinutes() : endDate.getMinutes();
                                var end = endhours + ":" + endminutes;

                                return (
                                    <>
                                        {/*item.Day + ", " + eventdate + " " + monthNames[startDate.getMonth()] + " " + startDate.getFullYear() + ": " + start + " - " + end*/}
                                        <span>{`${reduxLanguageTranslations ? reduxLanguageTranslations[item.Day] : ""}  ${eventdate} ${reduxLanguageTranslations ? reduxLanguageTranslations[monthNames[startDate.getMonth()]] : ""} ${startDate.getFullYear()} ${start} ${end}`}</span><br />
                                    </>
                                )
                            })
                            :
                            ""
                    }
                </div>
            </div>

            <p className="subtitle mb-3 d-flex justify-content-between align-items-center">
                <span> {reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalReqManageText"] : "Request to be managed by"} </span>
                {
                    reduxSetting.isVisitRequestManagementEnabled ?
                        <span>
                            {
                                reduxSetting.sendEmailTo == 1 ? reduxLanguageTranslations ?
                                    reduxLanguageTranslations["settingPageEstateOfficeEmailOpt"] : "Estate office email"
                                    :
                                    reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOtherOpt"] : "Other"
                            }
                        </span>
                        :
                        <span>{reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalAgentText"] : "Agent"}</span>
                }
            </p>

            <p className="subtitle mb-4 d-flex justify-content-between align-items-center">
                <span>{reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalSynFreeSlotText"] : "Synchronise the free slot in Whise"}</span>
                <span>{officeSettings.syncEventsToWhise ? reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalActivatedText"] : "Activated" : reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalNotActivatedText"] : "Not Activated"} </span>
            </p>

            <div className="mb-3 d-flex justify-content-between align-items-center">
                <p className="subtitle mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["autoAcceptRequest"] : "Automatically accept the request"}</p>
                <div>
                    <select className={`form-select`} id="automatic-accept-option" value={automaticSlotAccept} onChange={onChangeAutomaticAcceptVal}>
                        <option value="clientDefault">
                            {reduxLanguageTranslations ? reduxLanguageTranslations["clientDefault"] : "Client default"}
                            (
                            {
                                officeSettings.automaticSlotAcceptation ? 
                                reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes" 
                                :
                                reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"
                            }
                            )
                        </option>
                        <option className={`${officeDefaultOptShow != "" && officeDefaultOptShow.validationMessage == "office" ? "" : "d-none"}`} value="officeDefault">
                            {reduxLanguageTranslations ? reduxLanguageTranslations["officeDefault"] : "Office default"}
                            (
                            {
                                officeDefaultOptShow.automaticSlotAcceptation != "clientDefault" ?
                                    officeDefaultOptShow.automaticSlotAcceptation == "true" ?
                                        reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"
                                        :
                                        reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"
                                            : officeSettings.automaticSlotAcceptation ?
                                                reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"
                                                :
                                                reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"
                            }
                            )
                        </option>
                        <option value="true">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}</option>
                        <option value="false">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}</option>
                    </select>
                </div>
            </div>

            <div className="d-flex">
                <button type="button" className="filter-btn px-2 border-dark color-dark w-100 me-3" onClick={moveToSetupInvitee}>{reduxLanguageTranslations ? reduxLanguageTranslations["eventDetailModalBackBtn"] : "Back"}</button>
                <button type="button" className="site-btn site-btn-padd px-2 w-100" onClick={saveNewWhiseEvent}>{officeSettings.syncEventsToWhise ? reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalCreateSlotBtn"] : "Create slot and synchonise with WHISE" : reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalCreateSlotDBBtn"] : "Create Slot"}</button>
            </div>
        </>
    )
}